<!-- 第三方车场获取线上查费请求接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                            "parkCode": "2KNTYVWC",
                            "carCode": "粤EXX123",
                            "cardCode": "",
                            "needPayQrCode": "",
                            "parkingCode": "",
                            "couponList": [
                                {
                                    "couponName": "三小时优惠",
                                    "couponCode": "xxxx",
                                    "reliefType": "0",
                                    "faceValue": "10",
                                    "useRule": "",
                                    "maxReliefValue": "",
                                    "extraProperty": ""
                                }
                            ]
                        },
            responseCode: {
                "data": {
                    
                },
                "resultCode": 0,
                "message": "业务成功",
                "status": 1
            },
            infoData: {
                explain: "第三方车场缴费系统请求智慧停车开放平台，获取线上下发车场的查费请求",
                t_url: "https://openapi-test.yidianting.com.cn/openydt/comet/ajax",
                p_url: "https://openapi-dev.yidianting.xin/openydt/comet/ajax",
                precondition: "http轮训方式获取",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",                
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'data', info2: '数据', info3: 'JSONObject', info4: '结果数据' },
                    ]
                }, {
                    titleName: 'data',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [                        
                        { info1: 'carNumber', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'serviceName', info2: '是', info3: 'Long', info4: '接口名称' },
                        { info1: 'orderId', info2: '是', info3: 'String', info4: '订单记录号(车辆在停车场停车唯一订单编号，支持数字 字母 _ )' },
                        { info1: 'parkId', info2: '是', info3: 'String', info4: '车场编号' },
                        { info1: 'payScene', info2: '是', info3: 'Integer', info4: '支付场景，0：场内预付，1：结算待支付，2：无牌车请求结算，默认：0' },
                        { info1: 'outChannelId', info2: '否', info3: 'String', info4: '出场通道标识' },
                        { info1: 'queryOrderNo', info2: '是', info3: 'String', info4: '查询价格编号：本次收费系统查询价格的编号，返回时，原值返回，在预付通知中返回给收费系统' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForBolian/downThirdParkQueryFeeReq.vue